import './style.css';
import React, { useEffect } from 'react';
import { Nav } from 'react-bootstrap';
import { NotificationBell } from '../Icons';
import NotificationContainer from './NotificationContainer';
import NotificationCount from './NotificationCount';
import { useNotifications } from '../../../context';

export const NotificationNavButton = () => {
  const [show, setShow] = React.useState(false);
  const { disabled, notifications } = useNotifications();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Check if click is outside the container and not on popup-box
      if (
        !target.closest('.popup-box') &&
        !target.closest('.bell-button') &&
        show
      ) {
        setShow(false);
      }
    };

    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show]);

  const notificationCount = React.useMemo(
    () => notifications.filter((n) => !n.read_at).length,
    [notifications],
  );

  return (
    <div className="notification-container">
      <Nav.Link
        className={`bell-button ${show ? 'notification-active' : ''} h-100`}
        aria-label="Notification"
        onClick={() => {
          setShow(!show);
        }}
        disabled={disabled}
      >
        <NotificationBell active={show} />
        <NotificationCount count={notificationCount} loading={disabled} />
      </Nav.Link>
      <NotificationContainer
        show={show}
        notifications={notifications}
        onClose={() => setShow(false)}
      />
    </div>
  );
};
